import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const PassRevenue = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_ALL_OPERATOR_PASS_REVENUE:
      return { ...state, allOperatorsPassRevenue: action.value };
    case actions.CREATE_OPERATOR_PASS_REVENUE:
      return { ...state, createOperatorPassRevenueResponse: action.value };
    case actions.FETCH_OPERATOR_PASS_REVENUE_LIST:
      return { ...state, operatorPassRevenueList: action.value };
    case actions.CLEAR_OPERATOR_PASS_REVENUE_LIST:
      return { ...state, operatorPassRevenueList: action.value };
    case actions.FETCH_PASS_REVENUE_CITIES:
      return { ...state, passRevenueCities: action.value };
    case actions.PASS_REVENUE_UPLOAD_FAILURE:
      return { ...state, passRevenueUploadSheetError: action.value };
    default:
      return state;
  }
};

export default PassRevenue;
